const machine_txt = {
    type: "VA-0317S",
    name: "Double step intelligent computer synchronous sewing machine",
    description: [
        "Heighten design in rear cover and cover axis design to avoid oil leakage and operating more safely.",
        "Have the functions of automatic trimmer, automatic needle positioning,automatic counting and automatic reverse sewing.",
        "Sealed oil pan: back-stitched stepper motor, back-type design integrated with the casing, novel and beautiful;",
        "Electronic thread loosening: To prevent the thread clamp from not resettingwhen the seam is thick, you can select the thread loosening action switch whenlifting the presser foot. The thread loosening amount is stable and reliable, and the thread loosening intensity can be easily adjusted;",
        "Stepper motor thread trimming and presser foot lifting: the height of the automatic presser foot lifting can be adjusted freely; the electronic knee rest is very light and the thread trimming sound is very gentle; the stepper drive thread trimming and reset ensures stable thread trimming without the knife jamming,and the thread length is stable relatively stable.",
    ],
    //绝对路径
    machine_img:[
        "/assets/machine/20/machine_img/1.jpg",
        "/assets/machine/20/machine_img/2.jpg",
        "/assets/machine/20/machine_img/3.jpg",
    ],
    machine_other_img:[
        "/assets/machine/20/machine_other/1.png",
        "/assets/machine/20/machine_other/2.png",
    ]
}
export default {machine_txt}